import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";

interface ValidValueFormDialogProps {
  open: boolean;
  value: string;
  editIndex: number | null;
  isSaving: boolean;
  onClose: () => void;
  onSave: () => void;
  onChange: (value: string) => void;
}

const ValidValueFormDialog = ({
  open,
  value,
  editIndex,
  isSaving,
  onClose,
  onSave,
  onChange,
}: ValidValueFormDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {editIndex === null ? "Add Valid Value" : "Edit Valid Value"}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Value"
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && value.trim()) {
              onSave();
            }
          }}
          placeholder="e.g., Active, Pending, Completed"
          helperText="Enter a valid value for this field"
          disabled={isSaving}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={isSaving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={!value.trim() || isSaving}
        >
          {isSaving ? <CircularProgress size={20} /> : null}
          {!isSaving && editIndex === null ? "Add" : null}
          {!isSaving && editIndex !== null ? "Update" : null}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidValueFormDialog;
